import React, { useState } from "react";
import RoomModal from "./RoomModal";
import { Modal } from "react-bootstrap";

const roomBgColor = (room) => {
  if (Number(room?.ord_status) === 3 || room?.has_dispatch) {
    return "red";
  }
  return "lightblue";
};

function DeliveryRooms({ floorRooms, onRoomModalClose }) {
  const [room_Open_Modal, setroom_Open_Modal] = useState(false);
  const [room_Modal, setRoom_Modal] = useState(false);
  const [room_Name, setRoom_Name] = useState("");
  const [roomId, setRoomId] = useState("");
  const OpenRoomModal = (item) => {
    setroom_Open_Modal(true);
    setRoomId(item?.id);
    setRoom_Name(item?.name);
  };

  const CancelDeliverdModal = () => {
    setroom_Open_Modal(false);
    onRoomModalClose?.();
  };

  return (
    <div className="child-layout-set">
      <div className="containergo d-flex justify-content-center">
        <div className="room_main_div mt-5 ">
          {floorRooms.map((room, i) => {
            return (
              <div
                key={room?.id ?? i}
                className={`roombox cursor-pointer ${Number(room?.ord_status) === 3 || room?.has_dispatch ? "delivery-dispatch-room" : ""}`}
                style={{
                  display: `${
                    room?.id == 28 || room.id == 26 || room?.id == 24
                      ? "none"
                      : ""
                  }`,
                  backgroundColor: roomBgColor(room),
                  color:
                    Number(room?.ord_status) === 3 || room?.has_dispatch
                      ? "#fff"
                      : undefined,
                }}
                onClick={() => OpenRoomModal(room)}
              >
                {room?.name}
              </div>
            );
          })}
        </div>

        <Modal
          show={room_Open_Modal}
          onHide={CancelDeliverdModal}
          className="layout_set mb-0"
        >
          <Modal.Header style={{ backgroundColor: "lightblue" }}>
            <Modal.Title>{room_Name}</Modal.Title>
            <p
              className="text-bold cursor-pointer"
              onClick={CancelDeliverdModal}
            >
              x
            </p>
          </Modal.Header>
          <Modal.Body>
            <RoomModal key={roomId || "none"} roomId={roomId} />
          </Modal.Body>
          <Modal.Footer>
            <div className="custom_flex justify-content-end">
              <button
                onClick={CancelDeliverdModal}
                className="btn btn-secondary btn-sm active"
                role="button"
              >
                Cancel
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}

export default DeliveryRooms;
